// Library imports
import styled from 'styled-components';
import { MDBContainer } from 'mdb-react-ui-kit';
// Constant imports
import { POWER_BREAK_POINT } from '../PowerRank/constants';
import { SMALL_SCREEN_WIDTH } from '../../../../utils/constants';

export const InnerContent = styled(MDBContainer)`
    overflow-y: scroll;
    padding-top: 0.35rem;
    padding-bottom: 1rem;
    background: #0f1117 !important;
    touch-action: pan-y pinch-zoom;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar { display: none; }
`;

export const LineCard = styled.div`
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 14px;
    overflow: hidden;
    background: linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 100%);
    box-shadow: 0 10px 24px rgba(0,0,0,0.3);
    margin-bottom: 0.75rem;
`;

export const CardTitle = styled.span`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 800;
    font-size: 0.95rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
    padding: 0.75rem 0.85rem 0.6rem;
    position: relative;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.02);
    color: #e2e8f0;
    text-shadow: 0 1px 0 rgba(0,0,0,0.6);
    min-width: 0;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        font-size: 0.85rem;
        padding: 0.6rem 0.6rem 0.5rem;
    }
`;

// Truncates long team names inside the card title
export const TeamName = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const JuiceText = styled.span`
    font-size: 0.72em;
    font-weight: 700;
    opacity: 0.7;
    margin-left: 0.3rem;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        margin-left: 0.12rem;
    }
`;

export const HighLightedField = styled.span`
    ${props => props.width && `width: ${props.width};`}
    background: ${({ variant }) =>
        variant === 'success' ? 'rgba(34,197,94,0.12)' :
        variant === 'danger'  ? 'rgba(239,68,68,0.12)' :
        variant === 'primary' ? 'rgba(59,130,246,0.12)' :
        'rgba(255,255,255,0.05)'};
    border: 1px solid ${({ variant }) =>
        variant === 'success' ? 'rgba(34,197,94,0.4)' :
        variant === 'danger'  ? 'rgba(239,68,68,0.4)' :
        variant === 'primary' ? 'rgba(59,130,246,0.5)' :
        'rgba(255,255,255,0.1)'};
    color: ${({ variant }) =>
        variant === 'success' ? '#4ade80' :
        variant === 'danger'  ? '#f87171' :
        variant === 'primary' ? '#93c5fd' :
        '#cbd5e1'};
    text-align: center;
    padding: 0.55rem 0.5rem;
    font-weight: 700;
    border-radius: 10px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 2.3rem;
    font-size: 0.88rem;
    @media (max-width: ${POWER_BREAK_POINT}) {
        span { font-size: 13px; }
    }
    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        min-height: 1.85rem;
        padding: 0.3rem 0.2rem;
        border-radius: 8px;
        font-size: 0.8rem;
        line-height: 1.1;

        span { font-size: 0.66em; }
    }
`;

export const LineStatsGrid = styled.div`
    display: grid;
    grid-template-columns: ${({ $columns }) => `repeat(${$columns || 2}, minmax(0, 1fr))`};
    gap: 0.45rem;
    padding: 0.65rem 0.75rem 0.75rem;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        gap: 0.3rem;
        padding: 0.5rem 0.5rem 0.6rem;
    }
`;

export const LineStat = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    min-width: 0;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        gap: 0.22rem;
    }
`;

export const LineStatLabel = styled.span`
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #a5b4cf;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        font-size: 0.58rem;
        letter-spacing: 0.03em;
        text-align: center;
    }
`;

export const BookList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 0.65rem 0.75rem 0.75rem;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        padding: 0.5rem;
    }
`;

export const BookItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.4rem;
    padding: 0.55rem 0.65rem;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    transition: background 0.2s ease, border-color 0.2s ease;
    flex-wrap: wrap;

    &:hover {
        background: rgba(255,255,255,0.06);
        border-color: rgba(255,255,255,0.15);
    }

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        position: relative;
        overflow: hidden;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: stretch;
        gap: 0.25rem;
        padding: 0.5rem 2.5rem 0.5rem 0.6rem;
        min-height: 3.9rem;
    }
`;

export const BookInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    min-width: 0;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        width: 100%;
        flex: 0 0 auto;
        gap: 0.4rem;
        justify-content: flex-start;
    }
`;

export const BookLogo = styled.img`
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: ${({ $bookColor }) => $bookColor || 'linear-gradient(160deg, rgba(15,23,42,0.95) 0%, rgba(2,6,23,0.95) 100%)'};
    padding: 2px;
    object-fit: contain;
    flex-shrink: 0;
    border: 1px solid rgba(148,163,184,0.45);
    box-shadow: 0 1px 4px rgba(0,0,0,0.35);
`;

export const BookLabel = styled.span`
    font-weight: 700;
    color: #cbd5e1;
    font-size: 0.8rem;
    letter-spacing: 0.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        text-align: left;
        font-size: 0.82rem;
        flex: 1 1 auto;
    }
`;

export const BookOdds = styled.div`
    display: flex;
    align-items: center;
    gap: 0.35rem;
    flex-shrink: 0;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        width: 100%;
        flex: 0 0 auto;
        justify-content: flex-start;
        padding-left: calc(22px + 0.4rem);
    }
`;

export const OddsValue = styled.span`
    font-weight: 800;
    font-size: 0.95rem;
    color: ${({ $isBest, $isWorst }) => ($isBest ? '#4ade80' : $isWorst ? '#f87171' : '#e2e8f0')};
    min-width: 56px;
    text-align: right;

    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        min-width: 0;
        text-align: left;
    }
`;

export const BestWorstBadge = styled.span`
    font-size: 0.62rem;
    padding: 0.22rem 0.45rem;
    border-radius: 999px;
    font-weight: 800;
    text-transform: uppercase;
    margin-left: 0.25rem;
    background: ${({ $type }) => ($type === 'best' ? 'rgba(34,197,94,0.2)' : 'rgba(239,68,68,0.2)')};
    color: ${({ $type }) => ($type === 'best' ? '#4ade80' : '#f87171')};
    border: 1px solid ${({ $type }) => ($type === 'best' ? 'rgba(34,197,94,0.4)' : 'rgba(239,68,68,0.4)')};

    /* Phones: collapse the pill into a colored strip on the row's right edge */
    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 2.25rem;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-left: 1px solid ${({ $type }) => ($type === 'best' ? 'rgba(34,197,94,0.45)' : 'rgba(239,68,68,0.45)')};
        border-radius: 0;
        font-size: 0;
        line-height: 1;

        &::after {
            content: '${({ $type }) => ($type === 'best' ? '▲' : '▼')}';
            font-size: 1.05rem;
            font-weight: 900;
        }
    }
`;
